export default class Island {
	static OASIS_STATUS_OCCUPIED = 1; // оазис захвачен каким-то королевством //свое значение
	static OASIS_STATUS_WILD = 2; // оазис не захвачен никем //свое значение
}
